// Auto-generated from continuousQuartiles.json - patterns as RLE
const patterns = {
  'default': {
    'Creeper': {
      rle: 'x = 3, y = 3\nobo$bo$obo!',
      description: 'Classic glider layout adapted to the stepped quartile rule; drifts with chunky motion.',
    },
    'Ring': {
      rle: 'x = 5, y = 5\nb3o$o3bo$o3bo$o3bo$b3o!',
      description: 'Hollow loop that breathes in quarter-step pulses as edges erode and rebuild.',
    },
    'ThreeLine': {
      rle: 'x = 3, y = 1\n3o!',
      description: '',
    },
    'Tree': {
      rle: 'x = 7, y = 4\n3bo$2b3o$b5o$7o!',
      description: '',
    },
    'Triangle': {
      rle: 'x = 3, y = 2\nbo$obo!',
      description: '',
    },
  },
};
export default patterns;
